import { lazy } from "react";
import { ALLOWED_MODULES } from "../../../constants/enums";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { CAMPAIGN_REPORTS_ROUTE } from "./campaignReports.constant";

const CampaignReportsList = Loadable(
    lazy(() =>
        import("./CampaignReportsList").then(({ CampaignReportsList }) => ({
            default: CampaignReportsList,
        }))
    )
);

export const campaignReportsRoutes = [
    {
        path: CAMPAIGN_REPORTS_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess={true}
                moduleIds={[]}
            >
                <CampaignReportsList />
            </AuthorizedRoute>
        ),
    },
];
